module.exports = __webpack_public_path__ + "static/media/pencil.dc278a99.svg";